export default __webpack_public_path__ + "static/media/astrox.8d47b67d.png";